export default {
  // AUTH
  'Ulams\\Auth\\Events\\AccountBlocked': 'Konto zablokowane',
  'Ulams\\Auth\\Events\\AccountConfirmed': 'Konto potwierdzone',
  'Ulams\\Auth\\Events\\AccountDeleted': 'Konto usuniete',
  'Ulams\\Auth\\Events\\AccountMustBeEnableByAdmin':
    'Konto musi został aktywowane przez administratora',
  'Ulams\\Auth\\Events\\AccountRegistered': 'Konto zarejestrowane',
  'Ulams\\Auth\\Events\\ForgotPassword': 'Zapomniano hasła',
  'Ulams\\Auth\\Events\\Login': 'Poprawnie zalogowano',
  'Ulams\\Auth\\Events\\Logout': 'Wylogowano',
  'Ulams\\Auth\\Events\\PasswordChanged': 'Hasło zmienione',
  'Ulams\\Auth\\Events\\ResetPassword': 'Hasło zresetowane',
  'Ulams\\Auth\\Events\\UserAddedToGroup': 'Użytkownik dodany do grupy',
  'Ulams\\Auth\\Events\\UserRemovedFromGroup': 'Użytkownik usunięty z grupy',
  // SETTINGS
  'Ulams\\Settings\\Events\\SettingPackageConfigUpdated': 'Pakiet ustawień został zaktualizowany',
  // CSV USER
  'Ulams\\CsvUsers\\Events\\UlamsImportedNewUserTemplateEvent':
    'Zaimportowano nowy szablon użytkownika',
  // TOPIC
  'Ulams\\TopicTypes\\Events\\TopicTypeChanged': 'Temat zmieniony',
  // CONSULTATIONS
  'Ulams\\Consultations\\Events\\ApprovedTerm': 'Termin konsultacji zatwierdzony',
  'Ulams\\Consultations\\Events\\ApprovedTermWithTrainer':
    'Termin konsultacji z trenerem zatwierdzony',
  'Ulams\\Consultations\\Events\\ChangeTerm': 'Termin konsultacji zmieniony',
  'Ulams\\Consultations\\Events\\RejectTerm': 'Termin konsultacji odrzucony',
  'Ulams\\Consultations\\Events\\RejectTermWithTrainer': 'Termin konsultacji dla trenera odrzucony',
  'Ulams\\Consultations\\Events\\ReminderAboutTerm': 'Przypomnienie o terminie konsultacji',
  'Ulams\\Consultations\\Events\\ReminderTrainerAboutTerm':
    'Przypomnienie o terminie konsultacji dla trenera',
  'Ulams\\Consultations\\Events\\ReportTerm': 'Zgłoszenie terminu konsultacji',
  // WEBINAR
  'Ulams\\Webinar\\Events\\ReminderAboutTerm': 'Przypomnienie o terminie webinaru',
  'Ulams\\Webinar\\Events\\WebinarTrainerAssigned': 'Trener został przypisany do webinaru',
  'Ulams\\Webinar\\Events\\WebinarTrainerUnassigned': 'Trener został wypisany z webinaru',
  // PAYMENT
  'Ulams\\Payments\\Events\\PaymentCancelled': 'Płatność anulowana',
  'Ulams\\Payments\\Events\\PaymentFailed': 'Błąd płatności',
  'Ulams\\Payments\\Events\\PaymentRegistered': 'Płatność zarejestrowana',
  'Ulams\\Payments\\Events\\PaymentSuccess': 'Płatność zakończona sukcesem',
  // COURSE
  'Ulams\\Courses\\Events\\CourseAccessFinished': 'Dostęp do kursu zakończył się',
  'Ulams\\Courses\\Events\\CourseAccessStarted': 'Dostęp do kursu wystartował',
  'Ulams\\Courses\\Events\\CourseAssigned': 'Kurs przypisany',
  'Ulams\\Courses\\Events\\CourseDeadlineSoon': 'Wkrótce nastąpi zakończenie kursu',
  'Ulams\\Courses\\Events\\CoursedPublished': 'Kurs opublikowany',
  'Ulams\\Courses\\Events\\CourseFinished': 'Kurs zakończony',
  'Ulams\\Courses\\Events\\CourseStarted': 'Kurs wystartował',
  'Ulams\\Courses\\Events\\CourseStatusChanged': 'Status kursu zmieniony',
  'Ulams\\Courses\\Events\\CourseTutorAssigned': 'Trener kursu przypisany',
  'Ulams\\Courses\\Events\\CourseTutorUnassigned': 'Trener kursu odpięty',
  'Ulams\\Courses\\Events\\CourseUnassigned': 'Kurs odpięty',
  'Ulams\\Courses\\Events\\TopicFinished': 'Temat kursu zakończony',
  // STATIONARY EVENT
  'Ulams\\StationaryEvents\\Events\\StationaryEventAssigned': 'Wydarzenie stacjonarne przypisane',
  'Ulams\\StationaryEvents\\Events\\StationaryEventUnassigned': 'Wydarzenie stacjonarne odpięte',
  'Ulams\\StationaryEvents\\Events\\StationaryEventAuthorAssigned':
    'Autor wydarzenia stacjonarnego przypisany',
  'Ulams\\StationaryEvents\\Events\\StationaryEventAuthorUnassigned':
    'Autor wydarzenia stacjonarnego odpięty',
  // CART
  'Ulams\\Cart\\Events\\AbandonedCartEvent': 'Porzucony koszyk',
  'Ulams\\Cart\\Events\\OrderCancelled': 'Zamówienie anulowane',
  'Ulams\\Cart\\Events\\OrderCreated': 'Zamówienie utworzone',
  'Ulams\\Cart\\Events\\OrderPaid': 'Zamówienie zapłacone',
  'Ulams\\Cart\\Events\\ProductableAttached': 'Wszystkie typy produktów dołączone',
  'Ulams\\Cart\\Events\\ProductableDetached': 'Wszystkie typy produktów odłączone',
  'Ulams\\Cart\\Events\\ProductAddedToCart': 'Produkt dodany do koszyka',
  'Ulams\\Cart\\Events\\ProductAttached': 'Produkt dołączony',
  'Ulams\\Cart\\Events\\ProductBought': 'Produkt zakupiony',
  'Ulams\\Cart\\Events\\ProductDetached': 'Produkt odłączony',
  'Ulams\\Cart\\Events\\ProductRemovedFromCart': 'Produkt usunięty z koszyka',
  // TEMPLATES
  'Ulams\\Templates\\Events\\ManuallyTriggeredEvent': 'Ręcznie wyemitowane wydarzenie',
  // ASSIGN WITHOUT ACCOUNT
  'Ulams\\AssignWithoutAccount\\Events\\AssignToProductable':
    'Przypisz do wszystkich typów produktów',
  'Ulams\\AssignWithoutAccount\\Events\\AssignToProduct': 'Przypisz do produktów',
  // Youtube
  'Ulams\\Youtube\\Events\\YtProblem': 'Błąd youtube',
  // COURSE ACCESS
  'Ulams\\CourseAccess\\Events\\CourseAccessEnquiryAdminCreatedEvent':
    'Wydarzenie utworzone przez administratora dotyczące dostępu do kursu',
  // TASKS
  'Ulams\\Tasks\\Events\\TaskAssignedEvent': 'Zadanie przypisane',
  'Ulams\\Tasks\\Events\\TaskCompleteUserConfirmationEvent':
    'Potwierdzenie ukończenia zadania przez użytkownika',
  'Ulams\\Tasks\\Events\\TaskCompleteRequestEvent': 'Żądanie wykonania zadania',
  'Ulams\\Tasks\\Events\\TaskOverdueEvent': 'Opóźnione zadanie',
  'Ulams\\Tasks\\Events\\TaskIncompleteEvent': 'Zadanie niekompletne',
  'Ulams\\Tasks\\Events\\TaskNoteCreatedEvent': 'Notatka do zadania stworzona',
  // CONSULTATION ACCESS
  'Ulams\\ConsultationAccess\\Events\\ConsultationAccessEnquiryAdminCreatedEvent':
    'Zapytanie o dostęp do konsultacji utworzone przez administratora',
  'Ulams\\ConsultationAccess\\Events\\ConsultationAccessEnquiryDisapprovedEvent':
    'Odrzucenie zapytania o dostęp do konsultacji',
  'Ulams\\ConsultationAccess\\Events\\ConsultationAccessEnquiryApprovedEvent':
    'Zatwierdzono zapytanie o dostęp do konsultacji',
  // TOPIC TYPE PROJECT
  'Ulams\\TopicTypeProject\\Events\\ProjectSolutionCreatedEvent': 'Utworzenie rozwiązania projektu',
};
